import React, { Component } from 'react'
import { connect } from 'react-redux'
import Loader from '../Loader'
import classNames from 'classnames'
import _ from 'underscore'
import { sendTrackingData } from '@vmockinc/dashboard/services/tracking'
import { editModalAriaLabel } from '../Constants/AriaLabelText'
import ThreeDotsButton from './HelperComponents/ThreeDotsButton'
import SaveBtn from './HelperComponents/SaveBtn'
import { injectIntl, FormattedMessage } from 'react-intl'


class PersonalInformation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      focused: {
        profile_url: false,
        name: false,
      },
    }
    this.handleCloseButton = this.handleCloseButton.bind(this)
    this.handleUndoClick = this.handleUndoClick.bind(this)
    this.sendTrackingDataDebounceUndo = _.debounce(sendTrackingData, 3000, true)
  }

  handleChange(e) {
    let value = e.target.value
    let name = e.target.name
    if (name === 'profile_url') {
      value = 'https://www.linkedin.com/in/' + value
    }

    this.props.handleOnChangeData('personal_information', 0, name, value)
  }

  handleFocus(field, e) {
    e.preventDefault()
    let focused = this.state.focused
    for (let i in focused) {
      if (i == field) {
        focused[i] = true
      } else {
        focused[i] = false
      }
    }
    this.setState({ focused: focused })
  }

  handleBlur(field) {
    let focused = this.state.focused
    focused[field] = false
    this.setState({ focused: focused })
  }

  handleUndoClick() {
    const { currentIndex } = this.props
    let jsonObjectForTracking = {
      eventLabel: 'undo_changes_btn',
      currentSection: 'Personal Information',
      currentIndex: currentIndex,
    }

    this.sendTrackingDataDebounceUndo(
      'event',
      'aspire_edit_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )
    this.props.handleUndoData('personal_information', 0)
  }

  getUrlParam(linkedInUrl) {
    let param = linkedInUrl.slice(28)
    return param
  }

  handleCloseButton() {
    const {
      handleUndoData,
      currentIndex,
      hideEditModal,
      sectionWiseTextEditable,
      sectionWiseTextStatic,
    } = this.props
    let jsonObjectForTracking = {
      eventLabel: 'close_btn',
      currentSection: 'Personal Information',
      currentIndex: currentIndex,
    }
    sendTrackingData(
      'event',
      'aspire_edit_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )
    hideEditModal(
      'headline',
      currentIndex,
      sectionWiseTextEditable,
      sectionWiseTextStatic
    )
  }

  handleDisabledUrlClick(e) {
    $('.variable-url').focus()
    this.handleFocus('profile_url', e)
  }

  renderEntityText(entity) {
    const { has_pdf, sectionWiseTextEditable, savingChanges, intl } = this.props

    let fieldDisabled = false
    // if (savingChanges) {
    //   fieldDisabled = true
    // }

    if (entity == 'name') {
      if (has_pdf == 1) {
        return (
          <input
            type="text"
            className=""
            aria-label={intl.formatMessage({
              id: 'aspire.personalInformation.profileNameAria',
              defaultMessage: 'Enter your profile name'
            })}
            autoFocus
            name="name"
            id="profile_personal_name"
            value={sectionWiseTextEditable[0]['name']}
            placeholder={intl.formatMessage({
              id: 'aspire.personalInformation.profileNamePlaceholder',
              defaultMessage: 'Enter name'
            })}
            onChange={(e) => this.handleChange(e)}
            onFocus={(e) => this.handleFocus('name', e)}
            onBlur={() => this.handleBlur('name')}
            disabled={fieldDisabled}
          />
        )
      } else {
        return (
          <div className="as-edit-input-field-wrapper">
            <div className="as-input-div hide-scrollbar">
              {sectionWiseTextEditable[0]['name']}
            </div>
            <span className="text-red as-red-info-msg">
              <FormattedMessage
                id="aspire.personalInformation.uploadPdfMsg"
                defaultMessage="* Upload full LinkedIn pdf to edit your profile name."
              />
            </span>
          </div>
        )
      }
    }

    if (entity == 'profile_url') {
      let urlParam = this.getUrlParam(sectionWiseTextEditable[0]['profile_url'])
      return (
        <div className="display-flex">
          <div
            role="button"
            tabIndex={0}
            aria-label={'https://www.linkedin.com/in/ '}
            className={classNames('fixed-url', {
              'as-focused-profile-fixed-url': this.state.focused['profile_url'],
            })}
            onClick={(e) => this.handleDisabledUrlClick(e)}>
            https://www.linkedin.com/in/
          </div>
          <input
            type="text"
            className={classNames('variable-url', {
              'as-focused-profile-variable-url': this.state.focused[
                'profile_url'
              ],
            })}
            aria-label={intl.formatMessage({
              id: 'aspire.personalInformation.profileUrlAria',
              defaultMessage: 'Enter your profile URL'
            })}
            name="profile_url"
            id="profile_linkedin_url"
            value={urlParam}
            placeholder={intl.formatMessage({
              id: 'aspire.personalInformation.profileUrlPlaceholder',
              defaultMessage: 'Enter profile URL'
            })}
            onChange={(e) => this.handleChange(e)}
            onFocus={(e) => this.handleFocus('profile_url', e)}
            onBlur={() => this.handleBlur('profile_url')}
            disabled={fieldDisabled}
          />
        </div>
      )
    }
  }

  getSuggestedUrls() {
    const { sectionWiseText, tabIndex, intl } = this.props

    let suggestedUrls = [],
      temp = []

    if (!_.isEmpty(sectionWiseText['suggested_urls'])) {
      let len = sectionWiseText['suggested_urls'].length
      let divisor = 2
      let lenForEach = 6
      let temp2 = []
      let l = 0

      for (let i in sectionWiseText['suggested_urls']) {
        temp.push(
          <div
            className="as-suggested-urls-list-item"
            tabIndex={0}
            aria-label={sectionWiseText['suggested_urls'][i]}>
            {sectionWiseText['suggested_urls'][i]}
          </div>
        )
      }

      suggestedUrls = (
        <div className="as-suggested-urls-wrapper">
          <div className="suggestion-box">
            <div className="as-suggested-urls-heading">
              <span
                role="text"
                tabIndex={0}
                aria-label={
                  editModalAriaLabel(intl)['personal_info']['suggested_url']
                }
              >
                <FormattedMessage
                  id="aspire.personalInformation.suggestedUrlsHeading"
                  defaultMessage="Some suggested URLs"
                />
              </span>
            </div>
            <div className="as-suggested-urls-list">{temp}</div>
          </div>
          <span
            className="text-red as-red-info-msg"
            tabIndex={0}
            aria-label={editModalAriaLabel(intl)['personal_info']['availability']}>
            <FormattedMessage
              id="aspire.personalInformation.suggestedUrlsAvailability"
              defaultMessage="* Check availability of URLs on LinkedIn."
            />
          </span>
        </div>
      )
    }

    return suggestedUrls
  }

  getLabel(field, heading, emptyCondition) {
    const { savingChanges = false, intl } = this.props
    let colorClass = null
    if (_.isEmpty(emptyCondition)) {
      colorClass = 'as-edit-input-field-label text-red'
    } else if (savingChanges) {
      colorClass = 'as-edit-input-field-label as-label-text-color'
    } else if (this.state.focused[field]) {
      colorClass = 'as-edit-input-field-label as-focused-label-text-color'
    } else {
      colorClass = 'as-edit-input-field-label as-label-text-color'
    }

    return (
      <label htmlFor={field} className={colorClass}>
        {heading} <span className="text-red">*</span>
      </label>
    )
  }

  render() {
    const {
      savingChanges,
      currentIndex,
      sectionWiseTextStatic,
      sectionWiseTextEditable,
      showLogModal,
      handleSaveChanges,
      intl,
      isRightNavToggle,
    } = this.props

    let undoButton = null
    let saveDisabled = true
    if (
      !(
        JSON.stringify(sectionWiseTextEditable[currentIndex]) ===
          JSON.stringify(sectionWiseTextStatic[currentIndex]) || savingChanges
      )
    ) {
      saveDisabled = false
      undoButton = (
        <button
          tabIndex={0}
          aria-label={editModalAriaLabel(intl)['reset']}
          className="btn btn-undo-changes"
          onClick={this.handleUndoClick}>
          <FormattedMessage
            id="aspire.personalInformation.resetBtn"
            defaultMessage="Reset"
          />
        </button>
      )
    }

    let saveButton = (
      <SaveBtn
        savingChanges={savingChanges}
        saveDisabled={saveDisabled}
        handleSaveChanges={handleSaveChanges}
        intl={intl}
      />
    )

    let urlParam = this.getUrlParam(sectionWiseTextEditable[0]['profile_url'])

    let threeDotsBtn = (
      <ThreeDotsButton
        showLogModal={showLogModal}
        section='Personal Information'
      />
    )

    return (
      <div className="as-edit-wrapper scroll-hidden">
        <Loader sectionName="Personal Information" />
        <div className="as-edit-close-div">
          <a
            href="javascript:void(0);"
            aria-label={editModalAriaLabel(intl)['close']}
            onClick={this.handleCloseButton}
            className="icon-cross as-edit-close-btn modal-close-button"
            style={!isRightNavToggle ? { right: '17%' } : {}}
          />
        </div>
        <div className="as-edit-heading-wrapper">
          <div className="as-edit-heading" role="heading" aria-level="3">
            <FormattedMessage
              id="aspire.personalInformation.heading"
              defaultMessage="Personal Information"
            />
          </div>
          <div className="as-edit-actions-div">
            <div className="as-edit-action-undo">
              {undoButton}
            </div>
            <div className="as-edit-action-save">
              {saveButton}
            </div>
            {threeDotsBtn}
          </div>
        </div>
        <div className="as-edit-container as-personal-information-container">
          <div className="as-edit-inputs-row">
            <div className="as-edit-inputs-col">
              {this.getLabel(
                'profile_personal_name',
                intl.formatMessage({ id: "aspire.personalInformation.profileNameHeading", defaultMessage: "Profile Name" }),
                sectionWiseTextEditable[0]['name']
              )}
              {this.renderEntityText('name')}
            </div>
          </div>
          <div className="as-edit-inputs-row">
            <div className="as-edit-inputs-col">
              {this.getLabel('profile_linkedin_url',
                intl.formatMessage({ id: "aspire.personalInformation.profileUrlHeading", defaultMessage: "Profile URL" }),
                 urlParam)}
              {this.renderEntityText('profile_url')}
            </div>
            {this.getSuggestedUrls()}
          </div>
          <div className="as-edit-info-div">
            <div className="as-edit-suggestions-heading">
              <span
                tabIndex={0}
                aria-label={intl.formatMessage({
                  id: 'aspire.personalInformation.howToWriteUrl',
                  defaultMessage: 'How to write good profile URL'
                })}
              >
                <FormattedMessage
                  id="aspire.personalInformation.howToWriteUrl"
                  defaultMessage="How to write good profile URL"
                />
              </span>
            </div>
            <div className="as-edit-card-headline-education">
              <div className="as-sample-container-pi">
                <ul>
                  <li>
                    <FormattedMessage
                      id="aspire.personalInformation.urlTip1"
                      defaultMessage="A good custom URL should have 3-30 characters or numbers. Avoid using spaces, symbols, or special characters."
                    />
                  </li>
                  <li>
                    <FormattedMessage
                      id="aspire.personalInformation.urlTip2"
                      defaultMessage="We recommend using a variation of your name and/or your professional brand since you’ll share this URL with people. Some job applications may also ask you for your LinkedIn profile URL."
                    />
                  </li>
                  <li>
                    <FormattedMessage
                      id="aspire.personalInformation.urlTip3"
                      defaultMessage="The {isUKEnable, select, true {customisable} other {customizable}} part of the URL is case insensitive. This means using JohnDoe, johndoe or johnDoe will all point to the same profile."
                      values={{ isUKEnable: this.props.isUKEnable ? 'true' : 'false' }}
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


function mapStateToProps(state, ownProps) {
  return {
    savingChanges:
    !_.isEmpty(state.aspireFeedbackData.mini_loader_text) ||
    ownProps.uploadingEditedData,
    loaderInput: state.aspireFeedbackData.mini_loader_text,
    processedModulesCount: state.aspireFeedbackData.processed_modules_count,
    isRightNavToggle: state.editData.isRightNavToggle,
    isUKEnable: state.aspireFeedbackData.ukEnglish,
  }
}

export default injectIntl(connect(mapStateToProps, {})(PersonalInformation))
